import { render, staticRenderFns } from "./taskMgt.vue?vue&type=template&id=5ea7c3f8&scoped=true&"
import script from "./taskMgt.vue?vue&type=script&lang=js&"
export * from "./taskMgt.vue?vue&type=script&lang=js&"
import style0 from "./taskMgt.vue?vue&type=style&index=0&id=5ea7c3f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea7c3f8",
  null
  
)

export default component.exports